import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, Toutiao } from "../../types";
import { Http } from "../../utils/http";

export interface SearchToutiaoTopicListParams extends ActiomCommonParams {
    searchValue: string;
}

export type PublishAction = CommonAction<SearchToutiaoTopicListParams, Toutiao.Topic[]>;

export const searchToutiaoTopicList: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
        },
    });

    const res = await http.api<{ code: number; message: string; recents: Toutiao.Topic[]; hots: Toutiao.Topic[] }>({
        method: "get",
        url: "https://mp.toutiao.com/mp/agw/creator_helper/suggest_words",
        params: { type: 2, words: params.searchValue },
    });

    const isSuccess = res.code === 0;
    const message = `获取话题${isSuccess ? "成功" : `失败，原因：${res.message}`}`;
    const data = isSuccess ? (params.searchValue ? res.recents : res.hots) : [];

    return response(isSuccess ? 0 : 414, message, data);
};
